// Captura de fotos: cámara directa (1) o galería (varias). Ver hooks/useCamera.
import { useState } from 'react'
import { useCamera, type PhotoSource } from '@/hooks/useCamera'
import { Button } from './ui/Button'

interface Props {
  onCapture: (files: File[]) => void
}

export function PhotoCapture({ onCapture }: Props) {
  const { capture } = useCamera()
  const [previews, setPreviews] = useState<string[]>([])

  const pick = async (source: PhotoSource) => {
    const files = await capture(source)
    if (files.length === 0) return
    setPreviews(files.slice(0, 4).map((f) => URL.createObjectURL(f)))
    onCapture(files)
  }

  return (
    <div className="space-y-2">
      <div className="flex gap-2">
        <Button className="flex-1" onClick={() => pick('camera')}>
          📷 Tomar foto
        </Button>
        <Button variant="secondary" className="flex-1" onClick={() => pick('gallery')}>
          🖼️ De la galería (varias)
        </Button>
      </div>
      {previews.length > 0 && (
        <div className="flex gap-2">
          {previews.map((p, i) => (
            <img key={i} src={p} alt="Vista previa" className="h-20 w-20 rounded-lg border object-cover" />
          ))}
        </div>
      )}
    </div>
  )
}
